'use client';

import { Button } from '@app/ui-system';

import { setCookieAction } from '@/actions/setCookies';

export const CallToAction = () => {
  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => {
          setCookieAction({ name: 'cookie-consent', value: 'true' });
        }}
      >
        Akceptuj
      </Button>
      <Button
        variant="opacity"
        size="sm"
        onClick={() => {
          setCookieAction({ name: 'cookie-consent', value: 'false' });
        }}
      >
        Odrzuć
      </Button>
    </>
  );
};
